import {
  savedViewListResponseSchema,
  savedViewSchema,
  type RunFilter,
  type SavedView,
} from '@console/types'
import { z } from 'zod'
import { apiDelete, apiGet, apiPost } from '../api.js'
import { fetchCsrfToken } from '../auth/api.js'

export async function fetchSavedViews(): Promise<SavedView[]> {
  const { views } = await apiGet('/saved-views', savedViewListResponseSchema)
  return views
}

export async function createSavedView(name: string, filter: RunFilter): Promise<SavedView> {
  const csrfToken = await fetchCsrfToken()
  return apiPost('/saved-views', { name, filter }, csrfToken, savedViewSchema)
}

export async function deleteSavedView(id: string): Promise<void> {
  const csrfToken = await fetchCsrfToken()
  await apiDelete(`/saved-views/${encodeURIComponent(id)}`, csrfToken, z.void())
}
